import { ChangeDetectionStrategy, Component, OnInit, inject, signal } from '@angular/core';
import { TuiAvatar } from '@taiga-ui/kit';
import { UserProfileService } from '../../services/user-profile.service';
import { IUserProfile } from 'ngx-register-base';
import {
  TuiButton,
  TuiDropdownDirective,
  TuiDropdownManual,
  TuiDropdownOptionsDirective,
} from '@taiga-ui/core';
import { TuiActiveZone, TuiObscured } from '@taiga-ui/cdk';

@Component({
  selector: 'sma-user-info',
  standalone: true,
  templateUrl: './nagr-user-info.component.html',
  styleUrl: './nagr-user-info.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TuiAvatar,
    TuiDropdownDirective,
    TuiDropdownManual,
    TuiDropdownOptionsDirective,
    TuiActiveZone,
    TuiObscured,
    TuiButton,
  ],
})
export class NagrUserInfoComponent implements OnInit {
  protected readonly _usr = inject(UserProfileService);
  protected user!: IUserProfile;
  public fullname = signal<string>('');
  public login = signal<string>('');
  public icon = signal<string>('');
  protected open = false;

  public ngOnInit(): void {
    this.user = this._usr.getUserProfile();
    this.fullname.set(`${this.user.lastName ?? 'admin'} ${this.user.firstName ?? 'admin'}`);
    this.login.set(`${this.user.username ?? 'admin'}`);
    this.icon.set(`${this.user.photo || '@tui.user'}`);
  }

  protected onClick(): void {}

  protected logOut(): void {
    this.open = false;
    this._usr.logout();
  }

  protected onObscured(obscured: boolean): void {
    if (obscured) {
      this.open = false;
    }
  }

  protected onActiveZone(active: boolean): void {
    this.open = active && this.open;
  }
}
